import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card } from 'react-bootstrap';
import TournoisAffichageInscritJoueur from './AffichageTournoisInscritJoueur';
import TournoisAffichageAncien from './tournoisAffichageAncien';


const TournoisAffichageJoueur = (props) => {
    const [tournois, setTournois] = useState();
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const apiUrl = process.env.REACT_APP_API_URL;

    

    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
          try {
            const response = await axios.get(
              `${apiUrl}/tournois/affichage/${props.userData.user.donnée.results[0].id_equipe}`,
              {
                withCredentials: true 
              }
            );
            setTournois(response.data);
            setError(null);
            setIsLoading(false);
            
    
          } catch (error) {
            if (error.response) {
                
              setError(error.response.data.message);
            } else {
           
              setError(true)
            }
            setIsLoading(false);
    
          }
        };
    
        fetchData(); 
      }, [apiUrl, props.userData.user.donnée.results]);


      if (isLoading) {
        return (
        <div className="centered-content">
          <img src="/img/logo.png" alt="Logo" className="centered-logo" />
          <br/>
          <span className="loader"></span>
        </div>
        
        );  
      }
      if(error){
          return (
              <>
              <div id="alert-message" className="alert4" >
                  <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
              </div>
            </>  
          )
      }

  return (
    <>
            {tournois  ? (
            <>
                <Card.Title as="h3" className="mb-0"><strong>Tournois inscrit</strong></Card.Title>
                <hr/>
                <br/>
                <TournoisAffichageInscritJoueur userData={props.userData} tournoisInscrit={tournois.tournoisInscrit} tournoisEquipe={tournois.tournoisEquipe}/>
                <Card.Title as="h3" className="mb-0"><strong>Anciens tournois</strong></Card.Title>
                <hr/>
                <br/>
                <TournoisAffichageAncien userData={props.userData} ancienTournoiInscrit={tournois.ancienTournoiInscrit} ancienTournoiCreer={tournois.ancienTournoiCreer}/>
            </>
        ):(
        <>

        </> 
        )}
    </>
  );
};

export default TournoisAffichageJoueur;
